import { Grid, Typography } from "@mui/material";
import AppButton from "component/button/AppButton";
import React, { useEffect } from "react";
import styles from "./PrequalFailureModal.module.css";
import TextField from "component/textField/TextField";
import { useForm } from "react-hook-form";
import { AiOutlineClose } from "react-icons/ai";
import { yupResolver } from "@hookform/resolvers/yup";
import { useGetPequalFailure } from "api/prequal";
import AppBackdrop from "component/appBackdrop/AppBackdrop";
import { prequalFailureSchema } from "schemas/mortgageCalc/MortgageCalcSchema";
import AuthModalLayout from "component/authModalLayout/AuthModalLayout";
import FailIcon from "component/failIcon/FaiIcon";

function PrequalFailureModal({ handleClose }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    resetField,
  } = useForm({ resolver: yupResolver(prequalFailureSchema) });

  const { isLoading, mutate, openModal, setOpenModal, prequalData } =
    useGetPequalFailure();

  useEffect(() => {
    if (!!prequalData) {
      resetField("firstName");
      resetField("lastName");
      resetField("email");
      resetField("phone");
    }
  }, [prequalData]);

  return (
    <div className={styles.auth_modal_layout}>
      <AiOutlineClose
        className={styles.close}
        fontSize="20px"
        onClick={handleClose}
      />
      <Grid container>
        <Grid xs="6">
          <div className={styles.messagebox}>
            <FailIcon/>
            <Typography variant="h6">Not Qualified</Typography>
            <Typography>

              To discuss an alternative, please fill the form below
            </Typography>
          </div>
        </Grid>
        <Grid xs="6" paddingLeft="58px">
          <div>
            <Grid container>
              <Grid paddingRight="8px" xs={12} sm={6}>
                <div className={styles.field}>
                  <TextField
                    errors={errors}
                    name="firstName"
                    register={register}
                    required={true}
                    type="text"
                    label="First Name"
                    placeholder="First Name"
                  />{" "}
                </div>
              </Grid>
              <Grid xs={12} sm={6}>
                <div className={styles.field}>
                  <TextField
                    errors={errors}
                    name="lastName"
                    register={register}
                    required={true}
                    type="text"
                    label="Last Name"
                    placeholder="Last Name"
                  />{" "}
                </div>
              </Grid>

              <Grid xs={12} sm={12}>
                <div className={styles.field}>
                  <TextField
                    errors={errors}
                    name="email"
                    register={register}
                    required={true}
                    type="text"
                    label="Email"
                    placeholder="Examplejoe@gmail.com"
                  />
                </div>
              </Grid>
              <Grid xs={12} sm={12}>
                <div className={styles.field}>
                  <TextField
                    errors={errors}
                    name="phone"
                    register={register}
                    required={true}
                    type="text"
                    label="Phone Number"
                    placeholder="08012345678"
                  />
                </div>
              </Grid>
            </Grid>

            <AppButton
              width="100%"
              btnText="Submit"
              textColor="white"
              btnBg="#0089FF"
              type={"submit"}
              handleAction={handleSubmit(mutate)}
              loading={isLoading}
            />
          </div>
        </Grid>
      </Grid>

      <AppBackdrop
        openModal={openModal}
        handleCloseModal={() => {}}
        children={
          <AuthModalLayout
            handleClose={() => {
              setOpenModal(false);
              handleClose();
            }}
            icon={'success'}
            primaryText="Success"
            btnText="Close"
            secondaryText="You entry has been successfully collected"
          />
        }
      />
    </div>
  );
}

export default PrequalFailureModal;
